import { Theme } from "@sloth-system/styled-utils";

const theme: Theme = {
  color: {
    primary: {
      main: "#0CAECA",
      light: "#97C1CD",
      light900: "#EBF0F4",
      light920: "#EDFCFF",
      light930: "#EBF5FA",
      light940: "#EBF8FA",
      light950: "#FCFFFF",
      light960: "#B3E7EA",
      light970: "#7FCFDD",
      light980: "#42C0D4",
      dark: "#385A76",
    },
    secondary: {
      main: "#F7AB7A",
      light: "#FFE6D6",
      light900: "#FFF3EB",
      dark: "#FF6400",
    },
    green: {
      main: "#00AD9F",
      light: "#00C9B9",
      dark: "#006855",
      light500: "#E1FAF4",
      light900: "#00C9B9",
      dark920: "#00889F",
    },
    red: {
      light: "#fbccdb",
      light200: "#FF5533",
      light500: "#FFF2F2",
      light600: "#fdf7f6",
      main: "#FF0000",
      dark: "#FF2B00",
    },
    yellow: {
      main: "#fbd46d",
      light: "#FFF9C6",
      light200: "#FFF7EF",
      dark: "#FBC02D",
    },
    orange: {
      main: "#FF7817",
      light: "#FF9E68",
      light200: "#FFA56B",
      dark: "#EF7A26",
    },
    gray: {
      bg: "#F2F7F7",
      lighter: "#ebf1f2",
      light: "#d1d8d9",
      light950: "#556466",
      light960: "#9CABAD",
      main: "#acbcbf",
      dark: "#333e40",
      dark200: "#00181C",
      darker: "#002126",
    },
    text: {
      main: "#FFFFFF",
      secondary: "rgba(0, 0, 0, 0.7)",
      hint: "rgba(0, 0, 0, 0.5)",
      dark: "#003443",
      light950: "#556466",
    },
    background: {
      main: "#0E0E0E",
      midLight: "#151515",
      light: "#222222",
    },
    common: {
      black: "#000",
      white: "#fff",
    },
    neutrals: {
      0: "#fff",
      50: "#f5f5f5",
      100: "#EAEAEA",
      150: "#E0E0E0",
      200: "#F0F4F4",
      250: "#F2F7F7",
      300: "#ccc",
      700: "#747474",
      750: "#616161",
      800: "#464646",
      850: "#004D64",
      900: "#000",
    },
    // action: {
    //   disabled: "rgba(255, 255, 255, 0.26)",
    //   disabledBackground: "rgba(255, 255, 255, 0.12)",
    // },
    // transparent: "transparent",
    // divider: "#252525",
  },
  typography: {
    scale: {
      _unit: "px",
      xs: 10,
      s: 12,
      xm: 14,
      m: 16,
      l: 18,
      xl: 24,
      xxl: 32,
    },
    weight: {},
    face: {
      main: "Vazir",
      mainBold: "Vazir-Bold",
      mainMedium: "Vazir-Medium",
      mainLight: "Vazir-Light",
    },
  },
  radii: {
    _unit: "px",
    xs: 4,
    s: 8,
    m: 12,
    xm: 16,
    l: 24,
    xl: 32,
    circle: 100,
  },
  space: {
    _base: 4,
    _unit: "px",
    xs: 0.5,
    s: 1,
    m: 2,
    xm: 3,
    l: 4,
    xl: 5,
    xxl: 6,
    xxxl: 8,
    huge: 20,
  },
};
export default theme;
